import React from 'react';

const ContributionGuidePopup = ({ isOpen, onClose, onProceed }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
            <div className="bg-white p-6 rounded-xl shadow-xl max-w-2xl w-full">
                <h2 className="text-2xl font-semibold mb-4 text-center text-[#002746]">How to Contribute APIs</h2>

                <div className="space-y-3 text-sm text-gray-700">
                    <p>Thank you for your interest in contributing! Please follow the steps below to contribute your API project:</p>

                    <ol className="list-decimal pl-5 space-y-2">
                        <li>Provide the <strong>Project Name</strong>, a brief <strong>Description</strong>, and the official <strong>Logo</strong>.</li>
                        <li>Upload the <strong>Swagger/OpenAPI file</strong> that describes your APIs.</li>
                        <li>Ensure each API includes a clear <strong>Name</strong> and concise <strong>Description</strong>.</li>
                        <li>Submit the form to request contributor access. Your request will be reviewed by our admin team.</li>
                    </ol>

                    <p>If you have any questions or need assistance,reach out to our support team at <a href='mailto:contact.appstudio@ltts.com' target='_blank' rel='noopener noreferrer' className='text-[#0075cf] hover:underline'>contact.appstudio@ltts.com</a> .</p>
                </div>

                <div className="mt-6 flex justify-end space-x-4">
                    <button
                        onClick={onClose}
                        className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium px-6 py-2 rounded"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onProceed}
                        className="bg-[#0075cf] hover:bg-[#005fa3] text-white font-medium px-6 py-2 rounded"
                    >
                        Submit For Approval
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ContributionGuidePopup;
